import React from 'react';
import Icon from '../../../components/AppIcon';

const MonthCard = ({ month, year, onClick }) => {
  const getDaysInMonth = () => {
    return new Date(year, month?.id, 0)?.getDate();
  };
  
  const getFirstDayOfMonth = () => {
    return new Date(year, month?.id - 1, 1)?.getDay();
  };
  
  const getCurrentDate = () => {
    const today = new Date();
    if (today?.getFullYear() === year && today?.getMonth() + 1 === month?.id) {
      return today?.getDate();
    }
    return null;
  };
  
  const renderMiniCalendar = () => {
    const daysInMonth = getDaysInMonth();
    const firstDay = getFirstDayOfMonth();
    const currentDate = getCurrentDate();
    const days = [];
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days?.push(
        <div key={`empty-${i}`} className="w-6 h-6" />
      );
    }
    
    // Add cells for each day of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const isToday = day === currentDate;
      days?.push(
        <div
          key={day}
          className={`
            w-6 h-6 flex items-center justify-center text-xs rounded
            ${isToday 
              ? 'bg-primary text-white font-semibold' :'text-muted-foreground hover:bg-muted/50'
            }
          `}
        >
          {day}
        </div>
      );
    }
    
    return days;
  };

  return (
    <div
      onClick={onClick}
      className={`
        ${month?.color}
        border-2 rounded-lg p-4 cursor-pointer
        transition-all duration-200
        hover:shadow-lg hover:scale-[1.02] hover:border-primary
        group
      `}
    >
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading text-lg font-semibold text-foreground">
          {month?.name}
        </h3>
        <Icon 
          name="ChevronRight" 
          size={20} 
          className="text-muted-foreground group-hover:text-primary transition-colors"
        />
      </div>
      
      <div className="mb-3">
        <p className="font-caption text-xs text-muted-foreground">
          {year} • {month?.days} days
        </p>
      </div>
      
      {/* Mini Calendar Grid */}
      <div className="grid grid-cols-7 gap-1 mb-2">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S']?.map((day, idx) => (
          <div
            key={idx}
            className="w-6 h-6 flex items-center justify-center text-xs font-semibold text-muted-foreground"
          >
            {day}
          </div>
        ))}
      </div>
      
      <div className="grid grid-cols-7 gap-1">
        {renderMiniCalendar()}
      </div>
      
      <div className="mt-3 pt-3 border-t border-border">
        <button
          className="text-xs text-primary hover:text-primary/80 font-medium flex items-center gap-1"
        >
          <span>View Month</span>
          <Icon name="ArrowRight" size={12} />
        </button>
      </div>
    </div>
  );
};

export default MonthCard;